export enum IssueSeverityLevel {
  HIGH = 50,
  MEDIUM = 40,
  LOW = 20,
}
